/**
 * DashboardGate — post-login role dispatcher.
 *
 * Login always navigates to /dashboard. This component:
 * - For parents: renders Dashboard.jsx (legacy, frozen)
 * - For admins: redirects to /app/admin/verifications
 * - For tutors: redirects to /app/tuteur/notes
 *
 * This keeps Login.jsx and Dashboard.jsx completely untouched.
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { roleHome } from '../../routes/roleHome';
import Dashboard from '../../pages/Dashboard';

const DashboardGate = () => {
  const { user } = useAuth();
  const roles = user?.roles ?? [];

  // Admin or tutor: redirect to their space
  if (roles.includes('admin') || roles.includes('tutor')) {
    return <Navigate to={roleHome(user)} replace />;
  }

  // Parent (or unknown): render legacy dashboard
  return <Dashboard />;
};

export default DashboardGate;
